import React, { useState } from 'react';
import CustomNavbar from './components/Navbar';
import Atendimento from './components/Atendimento';
import Home from './components/Home';
import Footer from './components/Footer';
import Projetos from './components/Projetos';
import SupervisaoEscolar from './components/SupervisaoEscolar';
import Grupos from './components/Grupos';
import Cursos from './components/Cursos';
import './App.css';

function App() {
  const [activeSection, setActiveSection] = useState('Cursos');  // 🔥 Estado global da seção ativa

  let content;
  switch (activeSection) {
    case 'Home':
      content = <Home setActiveSection={setActiveSection} />;
      break;
    case 'Projetos':
      content = <Projetos setActiveSection={setActiveSection} />;
      break;
    case 'Atendimento':
      content = <Atendimento setActiveSection={setActiveSection} />;
      break;
    case 'SupervisaoEscolar':
      content = <SupervisaoEscolar setActiveSection={setActiveSection} />;
      break;
    case 'Grupos':
      content = <Grupos setActiveSection={setActiveSection} />;
      break;
    case 'Cursos':
      content = <Cursos setActiveSection={setActiveSection} />;
      break;
    default:
      content = <Home setActiveSection={setActiveSection} />;
  }

  return (
    <div>
      <CustomNavbar activeSection={activeSection} setActiveSection={setActiveSection} />
      {content}
      <Footer />
    </div>
  );
}

export default App;
